const initialState = {
  isLoading: false,
  user: "",
  dashboard:"",
};
export default initialState;
